import React from 'react';
import NavRail from './NavRail';
import TopBar from './TopBar';
import styles from './CollateFrame.module.css';

const CollateFrame = ({ user, children }) => {
  return (
    <div className={styles.shell}>
      <NavRail />
      <div className={styles.main}>
        <TopBar user={user} />
        <main className={styles.content}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default CollateFrame;
